export default class Controller {
  constructor() {
    this.repository = null;
  }
}
